import React from "react";
import { InputGroup, FormControl, Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";

function StakingInputCard(props) {

  return (
    <Card className="sinput-card-view">
      <Card.Header>{props.title}</Card.Header>
      <Card.Body>
        <FormControl size="lg" placeholder="0" aria-label="Amount" type="number" />
      </Card.Body>
      <Button variant="warning">{props.title}</Button>
    </Card>
  );
}
export default StakingInputCard;
